import React from "react";
import styled from "styled-components";

const DividerComponent = styled.span`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    :before {
        content: "";
        bottom: 0;
        right: 0;
        height: 100%;
        width: 1px;
        border-left: 1px solid ${(props) => props.theme.borderPrimary};
    }
`;

interface ButtonDividerProps {
    className?: string;
}
export default function ButtonDivider(props: ButtonDividerProps) {
    return <DividerComponent className={props.className} />;
}
